import { render } from "./DatesShiftsAE.component.vue?vue&type=template&id=206a61b5"
import script from "./DatesShiftsAE.component.vue?vue&type=script&lang=js"
export * from "./DatesShiftsAE.component.vue?vue&type=script&lang=js"

import "./DatesShiftsAE.component.vue?vue&type=style&index=0&id=206a61b5&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__